interface TransferIconProps {
  className?: string
}

export const TransferIcon = ({ className }: TransferIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
    className={className}
  >
    <g fill="#2962FF" clipPath="url(#clip0_253_15358)">
      <path d="M15.833 21.667a1.667 1.667 0 0 0-1.666 1.666v3.334H5.833v-3.334a1.667 1.667 0 1 0-3.333 0V35a1.667 1.667 0 0 0 1.667 1.667h11.666A1.666 1.666 0 0 0 17.5 35V23.333a1.667 1.667 0 0 0-1.667-1.666M35.833 21.667a1.667 1.667 0 0 0-1.666 1.666v3.334h-8.334v-3.334a1.667 1.667 0 0 0-3.333 0V35a1.666 1.666 0 0 0 1.667 1.667h11.666A1.666 1.666 0 0 0 37.5 35V23.333a1.667 1.667 0 0 0-1.667-1.666M28.334 13.333v1l-2.167-2.166a1.582 1.582 0 0 0-2.5.166 1.75 1.75 0 0 0 .167 2.25l5 4.917a1.583 1.583 0 0 0 2.333 0l5-4.917a1.75 1.75 0 0 0 .167-2.25 1.584 1.584 0 0 0-2.5-.166l-2.167 2.166v-1a11.666 11.666 0 1 0-23.333 0v5a1.667 1.667 0 0 0 3.333 0v-5a8.333 8.333 0 1 1 16.667 0"></path>
    </g>
    <defs>
      <clipPath id="clip0_253_15358">
        <path fill="#fff" d="M0 0h40v40H0z"></path>
      </clipPath>
    </defs>
  </svg>
)
